import React from 'react';

import { Box, Breadcrumb, Heading, Text, Flash } from '@primer/components'
import { Link } from "react-router-dom";

import WaveHero from '../../components/WaveHero';
import AdviceList from '../../components/AdviceList'
import Seo from '../../components/Seo'
import { useProduct } from '../../hooks/useProduct'

export const MESSAGE_IDS = [
  'C9000',
  'C9001',
  'C9002',
  'C9003',
  'C9004',
]


export default function(props) {
  const productDetails = useProduct()
  return (
    <Box>
      <Seo title="Django performance best practice" />
      <WaveHero>
        <Box className="container-lg lead text-white pt-2 pb-9 pb-md-8 pt-md-8 pl-4 pl-md-0">
          <Breadcrumb>
            <Breadcrumb.Item as={Link} to={'/'} className="text-white">Home</Breadcrumb.Item>
            <br/>
          </Breadcrumb>
          <Heading className="mb-0 text-white" style={{ display: 'block' }}>Improve your Django website speed</Heading>
        </Box>
      </WaveHero>
      <div className="container-lg px-3 mb-9" style={{fontSize: "16px"}}>
        <Box alignItems="center" className="container-lg clearfix d-md-flex">
          <Box className="col-md-6 float-right">
            <img src="/time.svg" width="100%" alt="Time" />
          </Box>
          <Box className="f3 col-md-6 float-left">
            <Text as="p">Over half of Django websites <a rel="noopener noreferrer" href="https://dev.to/djangodoctor/666-django-projects-checked-for-inefficient-database-queries-over-half-had-these-4-anti-patterns-4383" target="_blank">are being slowed down</a> by inefficient code. This is a problem because customers leave slow websites.</Text>
            <Text as="p">Code Review Doctor checks that your code follows the Django documentation database best practices, and offers the fix to reduce developer effort.</Text>
            <Text as="p">This improves customer bounce rate by helping prevent your website from being slowed by inefficient code.</Text>
          </Box>
        </Box>
        <Flash className="f3">Try the <Link to="/features/django/challenge/database-queries" target="_blank">Code Review Doctor database performance challenge</Link> to see the improvements Code Review Doctor suggests.</Flash>
        <Heading fontSize="4" className="mt-6">Code Review Doctor checks for the following database performance anti-patterns:</Heading>

        <AdviceList messageIds={MESSAGE_IDS} />
        <Text as="p" className="f3 pt-md-4">Are you ready to improve your Django performance? <a href={productDetails.gitHubMarketplaceLink}>Add {productDetails.name} to GitHub</a>.</Text>
      </div>
    </Box>
  );
}
